import { Component, Output, EventEmitter, Input, WritableSignal, signal, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipListbox, MatChipSelectionChange, MatChipsModule } from '@angular/material/chips';
import { ISelectionGroup, ISelectionItem } from './aggrid-group-selection.interface';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoCoreModule } from 'app/core/transloco/transloco.module';
import { ColDef } from 'ag-grid-community';

@Component({
  selector: 'app-aggrid-group-selection',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatChipsModule,
    MatIconModule,
    TranslocoCoreModule,
  ],
  templateUrl: './aggrid-group-selection.component.html',
  styleUrl: './aggrid-group-selection.component.scss'
})
export class AggridGroupSelectionComponent {

  @Input()
  public set dataSource(items: ISelectionGroup[]) {
    this.items.set(
      items
        .filter(item => item?.enableRowGroup)
        .sort((a, b) => (b?.order || 0) - (a?.order || 0))
    );
  }

  @Input()
  public multiple = true;
  @Input()
  public selectedItems: ISelectionItem[] = [];
  @Output()
  public selectionGroupChanges = new EventEmitter();

  @ViewChild("matChipRef", { static: true })
  public matChipRef!: MatChipListbox;

  public items: WritableSignal<ColDef[]> = signal<ColDef[]>([]);

  public selectionChange(event: MatChipSelectionChange, item: ColDef) {
    this.items.update(items => {
      return items.map(i => {
        if (i.field === item.field) {
          i.rowGroup = event.selected;
        }
        return i;
      });
    });

    this.selectionGroupChanges.emit(this.items());
  }
}
